module.exports = __webpack_public_path__ + "static/tagore-fa96e47efd57597dc363ee8c66b8b122.jpg";